// Fragment "consult console" — Payment Gateway v1, Flow C (Milestone B). The two new
// GatewayConsole.jsx tabs: the pricing-approval queue (GET/POST .../pricing/pending,
// approve, reject) and the consults list + SessionTimeline drill-down. `gw.state.session.*`
// mirrors contract §7's session state set, same "gw.state.*" convention every other
// enum in this console already uses.
export default {
  fr: {
    "gw.console.tab.consultPricing": "Tarifs en attente",
    "gw.console.tab.consults": "Téléconsultations",
    "gw.console.tab.awaitingOperator": "En attente d'un opérateur",

    "gw.console.consultPricing.colTenant": "Praticien",
    "gw.console.consultPricing.colCurrent": "Tarif actuel",
    "gw.console.consultPricing.colProposed": "Tarif proposé",
    "gw.console.consultPricing.colBand": "Fourchette autorisée",
    "gw.console.consultPricing.empty": "Aucun tarif en attente d'approbation.",
    "gw.console.consultPricing.approve": "Approuver",
    "gw.console.consultPricing.reject": "Refuser",
    "gw.console.consultPricing.approved": "Tarif approuvé.",
    "gw.console.consultPricing.rejected": "Tarif refusé.",
    "gw.console.consultPricing.rejectTitle": "Refuser ce tarif",
    "gw.console.consultPricing.rejectDesc": "Le tarif actuellement en vigueur reste appliqué.",
    "gw.console.consultPricing.rejectReasonPlaceholder": "Motif du refus (au moins 5 caractères)",
    "gw.console.consultPricing.rejectConfirm": "Confirmer le refus",

    "gw.console.consults.colId": "Rendez-vous",
    "gw.console.consults.colTenant": "Praticien",
    "gw.console.consults.colStatus": "Statut",
    "gw.console.consults.colEvidence": "Qualité de la preuve",
    "gw.console.consults.colMinutes": "Minutes facturées",
    "gw.console.consults.colAmount": "Montant encaissé",
    "gw.console.consults.empty": "Aucune téléconsultation pour l'instant.",
    "gw.console.consults.viewTimeline": "Voir le déroulé",
    "gw.console.consults.retryTimeline": "Réessayer de charger le déroulé",
    "gw.console.consults.timelineTitle": "Déroulé de la consultation",
    "gw.console.consults.evidence.server_events": "Événements serveur",
    "gw.console.consults.evidence.join_and_heartbeat": "Connexion + pulsations",
    "gw.console.consults.evidence.declared": "Déclarée",

    "gw.state.session.scheduled": "Planifiée",
    "gw.state.session.in_progress": "En cours",
    "gw.state.session.computing": "Calcul en cours",
    "gw.state.session.computed": "Calculée",
    "gw.state.session.captured": "Encaissée",
    "gw.state.session.void_no_show": "Absence — annulée",
    "gw.state.session.cancelled": "Annulée",

    "gw.console.awaitingOperator.hint": "Téléconsultations où l'horloge a tourné et le montant a été calculé, mais dont l'encaissement n'a pas abouti (autorisation expirée, carte refusée) — l'argent est réel et reste invisible tant qu'un opérateur ne l'a pas traité.",
    "gw.console.awaitingOperator.checking": "Vérification en cours…",
    "gw.console.awaitingOperator.unknown": "Impossible de vérifier pour le moment — ceci n'est PAS un état « rien à signaler ».",
    "gw.console.awaitingOperator.clear": "Aucune téléconsultation en attente d'un opérateur.",
    "gw.console.awaitingOperator.stuck": "{count} téléconsultation(s) en attente d'un opérateur.",
  },
  en: {
    "gw.console.tab.consultPricing": "Pending rates",
    "gw.console.tab.consults": "Telehealth consults",
    "gw.console.tab.awaitingOperator": "Awaiting an operator",

    "gw.console.consultPricing.colTenant": "Practitioner",
    "gw.console.consultPricing.colCurrent": "Current rate",
    "gw.console.consultPricing.colProposed": "Proposed rate",
    "gw.console.consultPricing.colBand": "Allowed band",
    "gw.console.consultPricing.empty": "No rate is awaiting approval.",
    "gw.console.consultPricing.approve": "Approve",
    "gw.console.consultPricing.reject": "Reject",
    "gw.console.consultPricing.approved": "Rate approved.",
    "gw.console.consultPricing.rejected": "Rate rejected.",
    "gw.console.consultPricing.rejectTitle": "Reject this rate",
    "gw.console.consultPricing.rejectDesc": "The currently active rate keeps applying.",
    "gw.console.consultPricing.rejectReasonPlaceholder": "Reason for rejection (at least 5 characters)",
    "gw.console.consultPricing.rejectConfirm": "Confirm rejection",

    "gw.console.consults.colId": "Appointment",
    "gw.console.consults.colTenant": "Practitioner",
    "gw.console.consults.colStatus": "Status",
    "gw.console.consults.colEvidence": "Evidence quality",
    "gw.console.consults.colMinutes": "Billed minutes",
    "gw.console.consults.colAmount": "Captured amount",
    "gw.console.consults.empty": "No telehealth consults yet.",
    "gw.console.consults.viewTimeline": "View timeline",
    "gw.console.consults.retryTimeline": "Try loading the timeline again",
    "gw.console.consults.timelineTitle": "Consult timeline",
    "gw.console.consults.evidence.server_events": "Server events",
    "gw.console.consults.evidence.join_and_heartbeat": "Join + heartbeats",
    "gw.console.consults.evidence.declared": "Declared",

    "gw.state.session.scheduled": "Scheduled",
    "gw.state.session.in_progress": "In progress",
    "gw.state.session.computing": "Computing",
    "gw.state.session.computed": "Computed",
    "gw.state.session.captured": "Captured",
    "gw.state.session.void_no_show": "No-show — voided",
    "gw.state.session.cancelled": "Cancelled",

    "gw.console.awaitingOperator.hint": "Telehealth consults where the clock ran and the amount was computed, but the capture never landed (expired authorisation, a declined card) — the money is real and stays invisible until an operator handles it.",
    "gw.console.awaitingOperator.checking": "Checking…",
    "gw.console.awaitingOperator.unknown": "Could not verify right now — this is NOT a \"nothing to report\" state.",
    "gw.console.awaitingOperator.clear": "No telehealth consults are awaiting an operator.",
    "gw.console.awaitingOperator.stuck": "{count} telehealth consult(s) awaiting an operator.",
  },
  es: {
    "gw.console.tab.consultPricing": "Tarifas pendientes",
    "gw.console.tab.consults": "Teleconsultas",
    "gw.console.tab.awaitingOperator": "Pendiente de un operador",

    "gw.console.consultPricing.colTenant": "Profesional",
    "gw.console.consultPricing.colCurrent": "Tarifa actual",
    "gw.console.consultPricing.colProposed": "Tarifa propuesta",
    "gw.console.consultPricing.colBand": "Rango permitido",
    "gw.console.consultPricing.empty": "No hay ninguna tarifa pendiente de aprobación.",
    "gw.console.consultPricing.approve": "Aprobar",
    "gw.console.consultPricing.reject": "Rechazar",
    "gw.console.consultPricing.approved": "Tarifa aprobada.",
    "gw.console.consultPricing.rejected": "Tarifa rechazada.",
    "gw.console.consultPricing.rejectTitle": "Rechazar esta tarifa",
    "gw.console.consultPricing.rejectDesc": "La tarifa actualmente vigente sigue aplicándose.",
    "gw.console.consultPricing.rejectReasonPlaceholder": "Motivo del rechazo (mínimo 5 caracteres)",
    "gw.console.consultPricing.rejectConfirm": "Confirmar rechazo",

    "gw.console.consults.colId": "Cita",
    "gw.console.consults.colTenant": "Profesional",
    "gw.console.consults.colStatus": "Estado",
    "gw.console.consults.colEvidence": "Calidad de la evidencia",
    "gw.console.consults.colMinutes": "Minutos facturados",
    "gw.console.consults.colAmount": "Monto cobrado",
    "gw.console.consults.empty": "Aún no hay teleconsultas.",
    "gw.console.consults.viewTimeline": "Ver cronología",
    "gw.console.consults.retryTimeline": "Volver a cargar la cronología",
    "gw.console.consults.timelineTitle": "Cronología de la consulta",
    "gw.console.consults.evidence.server_events": "Eventos del servidor",
    "gw.console.consults.evidence.join_and_heartbeat": "Conexión + pulsos",
    "gw.console.consults.evidence.declared": "Declarada",

    "gw.state.session.scheduled": "Programada",
    "gw.state.session.in_progress": "En curso",
    "gw.state.session.computing": "Calculando",
    "gw.state.session.computed": "Calculada",
    "gw.state.session.captured": "Cobrada",
    "gw.state.session.void_no_show": "Ausencia — anulada",
    "gw.state.session.cancelled": "Cancelada",

    "gw.console.awaitingOperator.hint": "Teleconsultas en las que el reloj corrió y el monto se calculó, pero el cobro nunca se concretó (autorización vencida, tarjeta rechazada) — el dinero es real y permanece invisible hasta que un operador lo gestione.",
    "gw.console.awaitingOperator.checking": "Verificando…",
    "gw.console.awaitingOperator.unknown": "No se pudo verificar en este momento — esto NO es un estado de «nada que reportar».",
    "gw.console.awaitingOperator.clear": "Ninguna teleconsulta está pendiente de un operador.",
    "gw.console.awaitingOperator.stuck": "{count} teleconsulta(s) pendiente(s) de un operador.",
  },
};
